import React, { useCallback, useState } from 'react';
import * as S from './Layout.styled';
import { useAppSelector } from 'redux/hooks';
import { selectPermission } from 'redux/global';
import AdminButtons from './components/AdminButtons';
import ErpSidebar from './components/ErpSidebar';
import Navigation from 'pages/Navigation/Navigation';
import { usePath } from 'pages/hooks';

const Layout = ({ children }:{ children: any }) => {
  const permission = useAppSelector(selectPermission);
  const { isHomePath } = usePath();
  const [isErpSidebarVisible, setIsErpSidebarVisible] = useState(false);
  const openErpSidebar = useCallback(() => setIsErpSidebarVisible(true), []);
  const closeErpSidebar = useCallback(() => setIsErpSidebarVisible(false), []);

  return (
    <S.Container>
      {
        (permission !== null && !isHomePath) && (
          <S.LeftPanel id="sidebar">
            <AdminButtons onOpenErpSidebar={openErpSidebar} />
            <ErpSidebar isVisible={isErpSidebarVisible} onClose={closeErpSidebar} />
          </S.LeftPanel>
        )
      }
      <S.RightPanel>
        <Navigation>
          {children}
        </Navigation>
      </S.RightPanel>
    </S.Container>
  );
};

export default Layout;
